import React from 'react';

import { CircularProgress } from '@mui/material';
import { Box, styled } from '@mui/system';

const StyledLoading = styled('div')(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& img': {
    width: 'auto',
    height: '25px'
  },
  '& .circleProgress': {
    position: 'absolute',
    left: -7,
    right: 0,
    top: 'calc(50% - 25px)'
  }
}));

const Loading = () => {
  return (
    <StyledLoading>
      {/* <Box position="relative">
        <CircularProgress className="circleProgress" />
      </Box> */}
        <div id="loader-wrapper">
        <div className="loader">
            <div className="loader__bar"></div>
            <div className="loader__bar"></div>
            <div className="loader__bar"></div>
            <div className="loader__bar"></div>
            <div className="loader__bar"></div>
            <div className="loader__ball"></div>
        </div>
        <div id="wifi-loader">
            <div className="text"></div>
        </div>
    </div>
    </StyledLoading>
  );
};

export default Loading;
